const PRODUCT_MAP = {
  'iPad1,1': 'iPad',
  'iPad2,1': 'iPad 2',
  'iPad2,2': 'iPad 2 (Wi-Fi + 3G)',
  'iPad2,3': 'iPad 2 (Wi-Fi + 3G)',
  'iPad2,4': 'iPad 2',
  'iPad2,5': 'iPad mini',
  'iPad2,6': 'iPad mini (Wi-Fi + Cellular)',
  'iPad2,7': 'iPad mini (Wi-Fi + Cellular)',
  'iPad3,1': 'iPad (3rd gen)',
  'iPad3,2': 'iPad (3rd gen, Wi-Fi + Cellular)',
  'iPad3,3': 'iPad (3rd gen, Wi-Fi + Cellular)',
  'iPad3,4': 'iPad (4th gen)',
  'iPad3,5': 'iPad (4th gen, Wi-Fi + Cellular)',
  'iPad3,6': 'iPad (4th gen, Wi-Fi + Cellular)',
  'iPad4,1': 'iPad Air',
  'iPad4,2': 'iPad Air (Wi-Fi + Cellular)',
  'iPad4,3': 'iPad Air (Wi-Fi + Cellular)',
  'iPad4,4': 'iPad mini 2',
  'iPad4,5': 'iPad mini 2 (Wi-Fi + Cellular)',
  'iPad4,6': 'iPad mini 2 (Wi-Fi + Cellular)',
  'iPad4,7': 'iPad mini 3',
  'iPad4,8': 'iPad mini 3 (Wi-Fi + Cellular)',
  'iPad4,9': 'iPad mini 3 (Wi-Fi + Cellular)',
  'iPad5,1': 'iPad mini 4',
  'iPad5,2': 'iPad mini 4 (Wi-Fi + Cellular)',
  'iPad5,3': 'iPad Air 2',
  'iPad5,4': 'iPad Air 2 (Wi-Fi + Cellular)',
  'iPad6,11': 'iPad (9.7-inch)',
  'iPad6,12': 'iPad (9.7-inch, Wi-Fi + Cellular)',
  'iPad6,3': 'iPad Pro (9.7-inch)',
  'iPad6,4': 'iPad Pro (9.7-inch, Wi-Fi + Cellular)',
  'iPad6,7': 'iPad Pro (12.9-inch)',
  'iPad6,8': 'iPad Pro (12.9-inch, Wi-Fi + Cellular)',
  'iPad7,1': 'iPad Pro (12.9-inch, 2nd gen)',
  'iPad7,2': 'iPad Pro (12.9-inch, 2nd gen, Wi-Fi + Cellular)',
  'iPad7,3': 'iPad Pro (10.5-inch)',
  'iPad7,4': 'iPad Pro (10.5-inch, Wi-Fi + Cellular)',
  'iPad7,5': 'iPad (6th gen)',
  'iPad7,6': 'iPad (6th gen, Wi-Fi + Cellular)',
  'iPad7,11': 'iPad (7th gen)',
  'iPad7,12': 'iPad (7th gen, Wi-Fi + Cellular)',
  'iPad8,1': 'iPad Pro (11-inch)',
  'iPad8,2': 'iPad Pro (11-inch)',
  'iPad8,3': 'iPad Pro (11-inch, Wi-Fi + Cellular)',
  'iPad8,4': 'iPad Pro (11-inch, Wi-Fi + Cellular)',
  'iPad8,5': 'iPad Pro (12.9-inch, 3rd gen)',
  'iPad8,6': 'iPad Pro (12.9-inch, 3rd gen)',
  'iPad8,7': 'iPad Pro (12.9-inch, 3rd gen, Wi-Fi + Cellular)',
  'iPad8,8': 'iPad Pro (12.9-inch, 3rd gen, Wi-Fi + Cellular)',
  'iPad8,9': 'iPad Pro (11-inch, 2nd gen)',
  'iPad8,10': 'iPad Pro (11-inch, 2nd gen, Wi-Fi + Cellular)',
  'iPad8,11': 'iPad Pro (12.9-inch, 4th gen)',
  'iPad8,12': 'iPad Pro (12.9-inch, 4th gen, Wi-Fi + Cellular)',
  'iPad11,1': 'iPad mini (5th gen)',
  'iPad11,2': 'iPad mini (5th gen, Wi-Fi + Cellular)',
  'iPad11,3': 'iPad Air (3rd gen)',
  'iPad11,4': 'iPad Air (3rd gen, Wi-Fi + Cellular)',
  'iPad11,6': 'iPad (8th gen)',
  'iPad11,7': 'iPad (8th gen, Wi-Fi + Cellular)',
  'iPad12,1': 'iPad (9th gen)',
  'iPad12,2': 'iPad (9th gen, Wi-Fi + Cellular)',
  'iPad13,1': 'iPad Air (4th gen)',
  'iPad13,2': 'iPad Air (4th gen, Wi-Fi + Cellular)',
  'iPad13,4': 'iPad Pro (11-inch, 3rd gen)',
  'iPad13,5': 'iPad Pro (11-inch, 3rd gen)',
  'iPad13,6': 'iPad Pro (11-inch, 3rd gen, Wi-Fi + Cellular)',
  'iPad13,7': 'iPad Pro (11-inch, 3rd gen, Wi-Fi + Cellular)',
  'iPad13,8': 'iPad Pro (12.9-inch, 5th gen)',
  'iPad13,9': 'iPad Pro (12.9-inch, 5th gen)',
  'iPad13,10': 'iPad Pro (12.9-inch, 5th gen, Wi-Fi + Cellular)',
  'iPad13,11': 'iPad Pro (12.9-inch, 5th gen, Wi-Fi + Cellular)',
  'iPad13,16': 'iPad Air (5th gen)',
  'iPad13,17': 'iPad Air (5th gen, Wi-Fi + Cellular)',
  'iPad13,18': 'iPad (10th gen)',
  'iPad13,19': 'iPad (10th gen, Wi-Fi + Cellular)',
  'iPad14,1': 'iPad mini (6th gen)',
  'iPad14,2': 'iPad mini (6th gen, Wi-Fi + Cellular)',
  'iPad14,3': 'iPad Pro (11-inch, 4th gen)',
  'iPad14,4': 'iPad Pro (11-inch, 4th gen, Wi-Fi + Cellular)',
  'iPad14,5': 'iPad Pro (12.9-inch, 6th gen)',
  'iPad14,6': 'iPad Pro (12.9-inch, 6th gen, Wi-Fi + Cellular)',
  'iPad14,8': 'iPad Air (11-inch, M2)',
  'iPad14,9': 'iPad Air (11-inch, M2, Wi-Fi + Cellular)',
  'iPad14,10': 'iPad Air (13-inch, M2)',
  'iPad14,11': 'iPad Air (13-inch, M2, Wi-Fi + Cellular)',
  'iPad15,3': 'iPad Air (11-inch, M3)',
  'iPad15,4': 'iPad Air (11-inch, M3, Wi-Fi + Cellular)',
  'iPad15,5': 'iPad Air (13-inch, M3)',
  'iPad15,6': 'iPad Air (13-inch, M3, Wi-Fi + Cellular)',
  'iPad15,7': 'iPad (A16)',
  'iPad15,8': 'iPad (A16, Wi-Fi + Cellular)',
  'iPad16,1': 'iPad mini (A17 Pro)',
  'iPad16,2': 'iPad mini (A17 Pro, Wi-Fi + Cellular)',
  'iPad16,3': 'iPad Pro (11-inch, M4)',
  'iPad16,4': 'iPad Pro (11-inch, M4, Wi-Fi + Cellular)',
  'iPad16,5': 'iPad Pro (13-inch, M4)',
  'iPad16,6': 'iPad Pro (13-inch, M4, Wi-Fi + Cellular)',
  x86_32: 'iPad Simulator (32-bit)',
  x86_64: 'iPad Simulator (64-bit)',
};
/* eslint-enable camelcase */
export default function appleProductName(deviceType) {
  return PRODUCT_MAP[deviceType] || deviceType;
}
